import { render } from "./SidebarNav.vue?vue&type=template&id=59948a24&scoped=true"
import script from "./SidebarNav.vue?vue&type=script&lang=js"
export * from "./SidebarNav.vue?vue&type=script&lang=js"

import "./SidebarNav.vue?vue&type=style&index=0&id=59948a24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59948a24"]])

export default __exports__